import axios from 'axios';

export default {
  find: function (id) {
    return axios.get(`/api/admin/users/find?id=${id}`);
  }
}